// Algolia returns at most this many values per facet on PLP queries (the widgets'
// showMoreLimit becomes maxValuesPerFacet on the request); facets that hit it are
// truncated. This module stays dependency-free so pure logic (and its jest tests)
// can import it without dragging in instantsearch.
export function facetValueRetrievalLimit () { return 100 }
